<template>
	<BasicBanner>
		<BasePlaceHolderInline width="75%" theme="dark" />
		<template #close-button><span></span></template>
	</BasicBanner>
</template>

<script setup lang="ts">
import BasicBanner from '@components/layout/basic-banner.vue';
</script>
